import type { RoutesTreeItem } from 'containers/App/Routes/RoutesTreeItem';
import { ExtensionsPage } from 'pages/Extensions/ExtensionsPage/ExtensionsPage';
import { NotFoundPage } from 'pages/NotFoundPage/NotFoundPage';

export const extensionsRoutes: RoutesTreeItem[] = [
  {
    path: '/extensions/overview',
    requiredApiScope: {
      method: 'GET',
      path: '/extensions',
    },
    element: <ExtensionsPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];
